import * as Users from '../services/Users'

export const SEARCH_USERS = 'SEARCH_USERS'
export const RECEIVE_USERS = 'RECEIVE_USERS'
export const RECEIVE_USER = 'RECEIVE_USER'

function searchUsersReponse(query, results) {
  return {
    type: RECEIVE_USERS,
    query: query,
    results: results
  }
}

function searchUserLicensesDashboardReponse(query, results) {
  return {
    type: RECEIVE_USERS,
    query: query,
    results: results
  }
}

export const searchUsers = (query) => (dispatch, getState) => {
  let subsidiaryId = getState().currentUser.subsidiary
  Users.searchUsers( query, subsidiaryId).then( (data) =>  dispatch(searchUsersReponse(query, data) ) )
}

export const getUserLicensesDashboard = (query) => (dispatch, getState) => {
  let subsidiaryId = getState().currentUser.subsidiary
  return Users.getUserLicensesDashboard( query, subsidiaryId).then( (data) =>  dispatch(searchUserLicensesDashboardReponse(query, data) ) )
}

export const getUserInfoDashboard = (query) => (dispatch, getState) => {
  let subsidiaryId = getState().currentUser.subsidiary
  return Users.searchUserInfoFromProductEAN( query, subsidiaryId).then( (data) =>  dispatch(searchUserLicensesDashboardReponse(query, data) ) )
}

export const getUserInfoAccounts = (query) => (dispatch, getState) => {
  let subsidiaryId = getState().currentUser.subsidiary
  return Users.searchUserInfoFromQuery( query, subsidiaryId).then( (data) =>  dispatch(searchUserLicensesDashboardReponse(query, data) ) )
}

export const switchLicensesUserId = (oldUserId, newUserId) => (dispatch, getState) => {
  let subsidiaryId = getState().currentUser.subsidiary
  Users.switchLicensesUserId( oldUserId, newUserId, subsidiaryId).then( (data) =>  dispatch(searchUserLicensesDashboardReponse( newUserId, data )) )
}

export const updateUserFederatedIdentityId = (body) => (dispatch, getState) => {
  let subsidiaryId = getState().currentUser.subsidiary

  return Users.updateUserFederatedIdentityId(body, subsidiaryId).then((data) => {
    dispatch(searchUserLicensesDashboardReponse(body, data))
    return data
  })
}

function receiveUser(state, user) {
  return {
    type: RECEIVE_USER,
    user: user ? user : {id: -1}
  }
}

export const fetchUser = (id) => (dispatch, getState) => {
  const state = getState()
  const subsidiaryId = state.currentUser.subsidiary
  Users.getUser(id, subsidiaryId).then((data) => dispatch(receiveUser(state, data)))
}
